// @mui material components
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import { useState } from 'react';

import CustomContainer from 'DS/components/Container';

// Material Kit 2 PRO React components
import MKBox from 'DS/components/MKBox';
import MKButton from 'DS/components/MKButton';
import MKTypography from 'DS/components/MKTypography';

import Button from 'assets/theme/components/button';

import { logosAcceleration, logosGrowth, logosIncubation } from 'contexts/companies';

function Portfolio() {
  const [arrayIndex, setArrayIndex] = useState(0);

  const BoxLogo = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#FFF',
    width: {
      xs: '100%',

      md: '160px',
    },
    height: '160px',
    boxShadow: '0px 2px 64px rgba(8, 0, 97, 0.08)',
    borderRadius: '10px',
    border: '2px solid #FFF',
    transition: 'all 150ms ease-in',
    '&:hover': {
      border: '2px solid #DB6639',
      boxShadow: '-6px 6px 0px 0px #DB6639',
      marginTop: '-6px',
      marginLeft: '6px',
      marginRight: '-6px',
    },
  };
  const theme = useTheme();

  function changeArray() {
    switch (arrayIndex) {
      case 0:
        return logosAcceleration;
      case 1:
        return logosIncubation;
      default:
        return logosAcceleration;
    }
  }
  function nextArray() {
    setArrayIndex((prevIndex) => (prevIndex + 1) % 3);
  }

  return (
    <section id="portfolio">
      <MKBox display="flex" py={6} position="relative" id="PortfolioAcademy">
        <CustomContainer>
          <MKBox pt={6} pb={3} textAlign="center" mt={4}>
            <Grid container spacing={1} justifyContent="center">
              <Grid item xs={12} lg={7} alignItems="center" flexDirection="column">
                <MKTypography variant="flywheel" color="primary">
                  PORTFOLIO
                </MKTypography>
                <MKTypography variant="h1" color="text" mb={1}>
                  <b>Who</b> we worked with
                </MKTypography>
              </Grid>
            </Grid>
          </MKBox>
          <MKBox display="flex" justifyContent="center" gap={2} mb={3}>
            <MKButton
              variant="contained"
              color={arrayIndex === 1 ? 'primary' : 'white'}
              sx={{
                ...Button,
                borderRadius: '10px',
              }}
              onClick={() => {
                setArrayIndex(1);
              }}
            >
              Incubation
            </MKButton>
            <MKButton
              variant="contained"
              color={arrayIndex === 0 ? 'primary' : 'white'}
              sx={{
                ...Button,
                borderRadius: '10px',
              }}
              onClick={() => {
                setArrayIndex(0);
              }}
            >
              Acceleration
            </MKButton>
          </MKBox>
          <MKBox
            display="flex"
            flexDirection="row"
            gap="16px"
            justifyContent="center"
            flexWrap="wrap"
            style={{ cursor: 'pointer' }}
          >
            {changeArray().map((item) => (
              <MKBox
                sx={{
                  ...BoxLogo,
                }}
                onClick={() => {
                  window.open(item.url);
                }}
              >
                {item.image ? (
                  <MKBox
                    className="img-card"
                    component="img"
                    src={item.image}
                    alt={item.name}
                    width="85px"
                    position="relative"
                    zIndex={1}
                    top="auto"
                  />
                ) : (
                  <MKTypography variant="h4" color="text" mb={1}>
                    {item.name}
                  </MKTypography>
                )}
              </MKBox>
            ))}
          </MKBox>
          {/* <MKBox pt={6} pb={8} textAlign="center">
          <Grid container spacing={1} justifyContent="center">
            <Grid item xs={12} lg={7} alignItems="center" flexDirection="column">
              <MKTypography variant="body1" color="text">
                Aconcagua provides lenders the latest tech-based collaterals. This new paradigm of
                lending will: 1) increase the base of clients; 2) increase the credit size; 3)
                decrease the interest rate.
              </MKTypography>
            </Grid>
          </Grid>
        </MKBox> */}
        </CustomContainer>
      </MKBox>
    </section>
  );
}

export default Portfolio;
